import React, {Fragment} from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import Contactpage from '../../components/Contactpage/Contactpage'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';

const ContactPage =() => {
    const { t } = useTranslation('contact');
    return(
        <Fragment>
            <Navbar/>
            <PageTitle pageTitle={t('pageTitle')} pagesub={t('pageTitle')}/>
            <Contactpage/>
            <Footer ftClass={'s2'}/>
            <Scrollbar/>
        </Fragment>
    )
};
export default ContactPage;

